<form [formGroup]="form" (ngSubmit)="submitted.next()" novalidate>
  <gpu-form-field class="gmb-8" [appearance]="formFieldAppearance">
    <gpu-label>{{ 'ANALYSES.SINGLE.RESULT' | translate }}</gpu-label>
    <gpu-select
      formControlName="value"
      [placeholder]="'ANALYSES.SINGLE.RESULT' | translate"
    >
      <gpu-option
        *ngFor="let option of configuration.markers[0].qualitativeValueWeights"
        [value]="option.value"
        >{{ option.key }}
      </gpu-option>
    </gpu-select>
  </gpu-form-field>

  <gpu-form-field *ngIf="showDate" [appearance]="formFieldAppearance">
    <gpu-label>
      {{ 'ANALYSES.ADD.DATE' | translate }}
    </gpu-label>
    <input
      #datepicker="ngbDatepicker"
      id="value-date"
      name="date"
      type="text"
      gpuDatepicker
      ngbDatepicker
      container="body"
      formControlName="date"
      [placeholder]="'ANALYSES.ADD.DATE' | translate"
      [datepicker]="datepicker"
      [maxDate]="now"
      [minDate]="minDate"
    />
    <i gpuSuffix class="gpicon-calendar"></i>
    <gpu-error *ngIf="form.controls.date?.errors?.required">
      {{ 'ANALYSES.ADD.REQUIRED' | translate }}
    </gpu-error>
  </gpu-form-field>
  <!-- this is only for "enter" to work as submit -->
  <button type="submit" style="display: none"></button>
</form>
